import { render } from "./CustomfieldsForm.vue?vue&type=template&id=50c28eef"
import script from "./CustomfieldsForm.vue?vue&type=script&lang=js"
export * from "./CustomfieldsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__